module.exports = __webpack_public_path__ + "img/sebe.bf9102cc.png";